import { studioMediaPath } from './studioMedia';

export const STUDIO_FINAL_OPTIONS = {
	personality: [
		'Vanilla',
		'Partying',
		'Toxic',
		'Guardian',
		'Noble',
		'Selfish',
		'Modest',
		'Brave',
		'Romantic',
		'Sweet',
		'Naughty',
		'Mature',
		'Luxury',
		'Fitness',
		'Bossy',
		'Nerdy',
	],
	occupation: [
		'Student',
		'Dancer',
		'Model',
		'Boss',
		'Bartender',
		'Engineer',
		'Teacher',
		'Fitness trainer',
		'Cook',
		'Artist',
		'Doctor',
		'Librarian',
		'Spy',
		'Police officer',
		'Soldier',
		'Lawyer',
		'Hairdresser',
		'Singer',
		'Writer',
		'Flight attendant',
		'Athlete',
		'Scientist',
		'Florist',
		'Photographer',
		'Designer',
		'Pharmacist',
		'Dietitian',
	],
	relationship: ['Single', 'Unknown', 'Neighbor', 'Friend', 'Crush', 'Girlfriend', 'Wife', 'Complicated'],
	nationality: [
		'American',
		'British',
		'Polish',
		'French',
		'Spanish',
		'Italian',
		'German',
		'Ukrainian',
		'Brazilian',
		'Mexican',
		'Japanese',
		'Korean',
		'Chinese',
		'Indian',
		'Egyptian',
		'Turkish',
		'Australian',
		'Canadian',
	],
	zodiac: [
		'Aries',
		'Taurus',
		'Gemini',
		'Cancer',
		'Leo',
		'Virgo',
		'Libra',
		'Scorpio',
		'Sagittarius',
		'Capricorn',
		'Aquarius',
		'Pisces',
	],
	kinks: ['Teasing', 'Praise', 'Roleplay', 'Dominant', 'Submissive', 'Voyeur', 'Exhibitionist', 'Slow burn'],
	voice: ['Voice 1', 'Voice 2', 'Voice 3', 'Voice 4', 'Voice 5', 'Voice 6'],
};

export const STUDIO_NAME_OPTIONS = [
	'Deborah',
	'Marta',
	'Elena',
	'Nadia',
	'Sofia',
	'Mila',
	'Kara',
	'Ava',
	'Lena',
	'Ivy',
];

export const STUDIO_RESULT_IMAGES = {
	woman: [
		studioMediaPath('bodytype-woman-athletic.png'),
		studioMediaPath('haircolor-woman-brunette.jpeg'),
		studioMediaPath('studio-woman.jpeg'),
	],
	men: [
		studioMediaPath('bodytype-men-athletic.jpeg'),
		studioMediaPath('bodytype-men-muscular.jpeg'),
		studioMediaPath('studio-men.jpeg'),
	],
	trans: [
		studioMediaPath('haircolor-trans-brunette.jpeg'),
		studioMediaPath('hairstyle-trans-wavy.jpeg'),
		studioMediaPath('studio-trans.jpeg'),
	],
};
